export default __webpack_public_path__ + "static/SRF Carasweet 5SGF7203 - Fiche de spécifications et données techniques-c7d0ad1a1f9da898bb215e583d28a0e8.pdf";